import Vue from 'vue';
import Vuex from 'vuex';
import { vuexfireMutations } from 'vuexfire';
import auth from '@/store/modules/Auth.module'; // eslint-disable-line import/no-cycle
import user from '@/store/modules/User.module';
import workspace from '@/store/modules/Workspace.module';
import team from '@/store/modules/Team.module';
import goal from '@/store/modules/Goal.module';
import ui from '@/store/modules/Ui.module';
import invitation from '@/store/modules/Invitation.module';
import standup from '@/store/modules/Standup.module';
import subscription from '@/store/modules/Subscription.module';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  mutations: {
    ...vuexfireMutations,
  },
  modules: {
    auth,
    user,
    workspace,
    team,
    goal,
    ui,
    invitation,
    standup,
    subscription,
  },
});
